export default __webpack_public_path__ + "static/media/Mask.190580cb.svg";